export default "https://cdn-static.gokick.com/assets/bc95401d28f090206b11ed03f14553a528aaf8ef/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";